/**
 * @author shengzhao
 * @file 命名格式以api开头，如apiGetProductList
 * @note 注意各模块的接口命名，这里导出的接口不能有重名
 * @note 引入方式减少从这里引入，从具体模块引入如@/service/login
 */
export * from './common';
export * from './login';
export * from './vip';
export * from './website';
export * from './product';
export * from './crowdfunding';
export * from './cacheOrCatch';
export * from './calculator';
export * from './quote';
export * from './quotation'; // 报价单 御見積書
export * from './question'; // 调查问卷
export * from './sms-subscribe'; // sms订阅
export * from './protable-power-station-questionnaire'; // delta3 调查问卷
export * from './support'; // support相关接口
export * from './shopify'; // support相关接口
export * from './ocean-pro-consultation'; // support相关接口
export * from './installerNearMe';
